module.exports = __webpack_public_path__ + "static/media/btn_green.c117b24f.png";